import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function NotFound() {
  return (
    <section className="auth-panel">
      <SEO title="Not Found" />
      <h1>Page not found</h1>
      <p>This page is not part of the story yet.</p>
      <Link className="button" to="/">Go home</Link>
    </section>
  );
}

export default NotFound;
